<template>
  <table class="contests-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" rowspan="2">
          <input type="checkbox" v-model="allSelected" class="mr-2">
          Id
        </th>
        <th scope="col" rowspan="2">Type</th>
        <th scope="col" rowspan="2">Audience</th>
        <th scope="col" rowspan="2">Status</th>
        <th scope="col" colspan="2" class="text-center">Start</th>
        <th scope="col" rowspan="2">Remaining time</th>
        <th scope="col" colspan="2" class="text-center">Finish</th>
        <th scope="col" rowspan="2" v-if="mayManageContests">Actions</th>
      </tr>
      <tr>
        <th scope="col">planned</th>
        <th scope="col">real</th>
        <th scope="col">planned</th>
        <th scope="col">real</th>
      </tr>
    </thead>
    <tr
      v-for="contestContainer in contestContainers"
      :key="contestContainer.contest.id"
      :class="getContestClass(contestContainer.contest.status)"
    >
      <td>
        <input type="checkbox" v-model="contestContainer.selected" class="mr-2">
        <contest-link :contestId="contestContainer.contest.id" label=""/>
      </td>
      <td><b>{{contestContainer.contest.type | getContestTypeName}}</b></td>
      <td>
        <span v-b-popover.hover.top="getPlayerGroupDescription(contestContainer.contest.playerGroupId)">
          {{contestContainer.contest.playerGroupId | getPlayerGroupName}}
        </span>
      </td>
      <td
        :class="getContestStatusClass(contestContainer.contest.status)"
      >
        {{contestContainer.contest.status | getContestStatusName}}
      </td>

      <td>{{contestContainer.contest.stime | getMomentMinStr}}</td>
      <td>{{contestContainer.contest.srtime | getContestRealStartTimeStr}}</td>

      <td>{{getRemainingTimeStr(contestContainer.contest)}}</td>

      <td>{{contestContainer.contest.ftime | getMomentMinStr}}</td>
      <td>{{contestContainer.contest.frtime | getContestRealFinishTimeStr}}</td>

      <td v-if="mayManageContests" class="action-box">
        <b-button
          v-if="mustShowFinishButton(contestContainer.contest)"
          @click="finalizeContest(contestContainer.contest)"
          variant="warning"
          size="sm"
        >
          Finish
        </b-button>
        <b-button
          @click="deleteContest(contestContainer.contest)"
          variant="danger"
          size="sm"
        >
          Delete
        </b-button>
      </td>
    </tr>
  </table>
</template>

<script>
import { getPlayerGroupName        } from '../model/event.js';
import { getPlayerGroupDescription } from '../model/event.js';

import { getContestTypeName          } from '../model/contest.js';
import { getContestStatusClass       } from '../model/contest.js';
import { getContestStatusName        } from '../model/contest.js';
import { getContestRealStartTimeStr  } from '../model/contest.js';
import { getContestRealFinishTimeStr } from '../model/contest.js';
import { getContestRemainingTimeStr  } from '../model/contest.js';
import { isContestActive             } from '../model/contest.js';
import { isContestClosed             } from '../model/contest.js';

import ContestLink from './ContestLink.vue';

export default {
  name: 'ContestTable',

  components: {
    ContestLink,
  },

  props: {
    contestContainers: {
      type: Array,
      required: true,
    },

    nowSec: {
      type: Number,
      required: true,
    },

    mayManageContests: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    allSelected: {
      get() {
        for(const container of this.contestContainers) {
          if(!container.selected) {
            return false;
          }
        }
        return true;
      },

      set(newValue) {
        if(newValue) {
          this.selectAll();
        } else {
          this.deselectAll();
        }
      },
    },
  },

  methods: {
    getPlayerGroupDescription,
    getContestStatusClass,

    getContestClass(status) {
      return {
        closed: isContestClosed(status)
      };
    },

    getRemainingTimeStr(contest) {
      return getContestRemainingTimeStr(contest, this.nowSec);
    },

    deleteContest(contest) {
      this.$emit('contest-deletion-requested', contest);
    },

    mustShowFinishButton(contest) {
      if(!this.mayManageContests) {
        return false;
      }
      return isContestActive(contest.status);
    },

    finalizeContest(contest) {
      this.$emit('contest-finalization-requested', contest);
    },

    selectAll() {
      this.$emit('contests-selection-requested');
    },

    deselectAll() {
      this.$emit('contests-deselection-requested');
    },
  },

  filters: {
    getPlayerGroupName,
    getContestTypeName,
    getContestStatusName,
    getContestRealStartTimeStr,
    getContestRealFinishTimeStr,
  },
};
</script>


<style scoped>
.closed {
  color: #dcdcdc;
}

.contests-table {
  width: 1px;
}

.action-box {
  padding: 7px;
  vertical-align: middle;
}

.action-box > .btn:last-child {
  margin-right: 0 !important;
}
</style>
